import localCache from './localCache';
import { STORAGE_KEYS } from './storageKeys';

const cleanImportLocationNotification = () => {
  localCache.remove(STORAGE_KEYS.IMPORT_LOCATION_ID);
  localCache.remove(STORAGE_KEYS.IMPORT_LOCATION_INTEGRATION_ID);
  localCache.remove(STORAGE_KEYS.SHOULD_DISPLAY_NOTIFICATION);
};

export default cleanImportLocationNotification;
